import { IProject } from '../../models/IProject';
import { IScript } from '../../models/IScript';
import * as types from './actionsTypes.codeMetaData';

export interface IParseCodeParam {
    codeString: string
    fileName: string
}
export function parseCode({ codeString, fileName }: IParseCodeParam) {
    return {
        type: types.CODE_CHANGE,
        codeString,
        fileName,
    };
}

export interface IParseAllScriptsParam {
    project: IProject
}

export function parseAllScripts({ project }: IParseAllScriptsParam) {
    return {
        type: types.PARSE_ALL_SCRIPTS,
        project
    };
}


export interface ICheckErrorsParam {
    project: IProject
    scripts: IScript[]
}
export function checkErrors({ project, scripts }: ICheckErrorsParam) {
    return {
        type: types.CHECK_ERRORS,
        project,
        scripts,
    };
}

export function reset() {
    return {
        type: types.CODE_META_DATA_RESET,
    };
}
